import { component } from 'common/util/ComponentDecorator';
import './checkout-payment-method.scss';

@component
export default class CheckoutPaymentMethod {
	static classname = 'checkout-payment-method';

	constructor($method) {
		this.$method = $method;
		const $chosenMethodContainer = $(document).find('.checkout-payment__chosen-method');

		let $chosenMethod = $('.checkout-payment-method_checked').find('.checkout-payment-method__name-container').text();
		$chosenMethodContainer.html(`Выбрано: ${$chosenMethod}`);

		this.$method.on('click', function() {
			const valArr = [];
			valArr.push($(this).find('.checkout-payment-method__control').val());
			$('input[name="payment_id"]').val(valArr).trigger('change');
			$('.checkout-payment-method').not(this).removeClass('checkout-payment-method_checked');
			$(this).addClass('checkout-payment-method_checked');
			$chosenMethod = $(this).find('.checkout-payment-method__name-container').text();
			$chosenMethodContainer.html(`Выбрано: ${$chosenMethod}`);
		});
	}
};
